module.exports = __webpack_public_path__ + "static/gallery49-d4d1c77d810795eb40cdc0c29d6b83f2.png";